interface GridState {
    active: boolean;
}

// TODO: type this — Vuex action context
type Ctx = any;

const GridStore = {
    namespaced: true,
    state: (): GridState => ({
        active: false,
    }),
    mutations: {
        toggle(state: GridState): void {
            state.active = !state.active;
        },
        reset(state: GridState): void {
            state.active = false;
        },
    },
    actions: {
        toggle({ commit }: Ctx): void {
            commit('toggle');
        },
        reset({ commit }: Ctx): void {
            commit('reset');
        },
    },
};

export default GridStore;
